
import React, {FC, PropsWithChildren} from 'react';
import {RenewInterval} from 'components/checkout/query/types';
import {QueryVars} from 'components/checkout/store/types.query';

export type SetupArgs = {
	interval?: RenewInterval
	quantity: number
}

export type PriceConfig = {
	setup?: (args: SetupArgs) => QueryVars
	modal?: boolean
}

type ProviderProps = {
	config: PriceConfig
}

const PriceContext = React.createContext<PriceConfig>({});

export const ConfigProvider: FC<PropsWithChildren<ProviderProps>> = ({children, config}) => {
	return (
		<PriceContext.Provider value={config}>
			{children}
		</PriceContext.Provider>
	);
};

export const useContextConfig = () => React.useContext(PriceContext);
